import React from 'react';
import ReactDOM from 'react-dom';
import { Provider } from 'react-redux';
import { store } from './app/store';
import App from './App';
import reportWebVitals from './reportWebVitals';
import './index.css';
import axios from "axios";
import moment from 'moment';
import momentTimezone from 'moment-timezone'
import { updateAuthKey } from "./features/ws/wsSlice";
import * as Sentry from "@sentry/react";
import { BrowserTracing } from "@sentry/tracing";
import { showGlobalNotification } from "./features/drycleaning/components/NotificationContext";

moment.locale('ru');
momentTimezone.tz.setDefault('Europe/Moscow');

Sentry.init({
  dsn: "https://5d4f7c48bc122a04569ba3586c6a6421@sentry.airotech.ru/6",
  integrations: [
    Sentry.browserTracingIntegration(),
    Sentry.replayIntegration(),
  ],
  tracesSampleRate: 1.0,
  tracePropagationTargets: ['https://lsystem.airo.ru'],
  replaysSessionSampleRate: 0.1,
  replaysOnErrorSampleRate: 1.0,
});


axios.defaults.withCredentials = true;
axios.defaults.baseURL = process.env.REACT_APP_API_BASE_URL;

// Response interceptor для обработки ошибок при загрузке маршрутов
axios.interceptors.response.use(
    (response) => {
        // Возвращаем успешный ответ как есть
        return response;
    },
    (error) => {
        // Проверяем, что это ошибка запроса к маршрутам
        const isRoutesRequest = error.config?.url?.includes('/lsystem/api/v1/drives-in-route');

        // Проверяем статус ошибки >= 500 или сетевую ошибку
        const isServerError = error.response?.status >= 500;
        const isNetworkError = !error.response && (error.code === 'ERR_NETWORK' || error.message?.includes('Network Error'));

        if (isRoutesRequest && (isServerError || isNetworkError)) {
            // Извлекаем сообщение об ошибке из ответа бэкенда
            let errorMessage = 'Не удалось загрузить маршруты';

            if (error.response?.data) {
                errorMessage = error.response.data.message
                    || error.response.data.error
                    || errorMessage;
            } else if (isNetworkError) {
                errorMessage = 'Ошибка сети при загрузке маршрутов';
            }

            // Показываем toast-уведомление (если NotificationProvider уже смонтирован)
            // Используем setTimeout чтобы дать время для монтирования компонента
            setTimeout(() => {
                showGlobalNotification(errorMessage, 'error');
            }, 100);
        }

        // Пробрасываем ошибку дальше для обработки в компонентах
        return Promise.reject(error);
    }
);

const updateUser = () => {
  // auth/options вместо admin/user/options: маршруты admin/* закрываются под VPN (CRM),
  // а этот эндпоинт остаётся доступным для логистики без VPN
  axios.get('/auth/options').then((response) => {
    store.dispatch(updateAuthKey(response.data.auth_key))
  }).catch((e) => {
    const status = e.response?.status;
    // 401/403 — сессия истекла; ERR_NETWORK — ответ без CORS-заголовков (например, 502/504).
    // Редирект на живую страницу логина логистики (/user/login на airo.ru отдаёт 404 от Next.js)
    if (status === 401 || status === 403 || e.code === "ERR_NETWORK") {
      window.location.href = process.env.REACT_APP_API_BASE_URL + '/auth/lsystem'
    }
  })
}

updateUser();
setInterval(() => updateUser(), 5000);

ReactDOM.render(
  // <React.StrictMode>
  <Provider store={store}>
    <App />
  </Provider>
  // </React.StrictMode>
  ,
  document.getElementById('root')
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
